export default __webpack_public_path__ + "static/media/icon_statement_next.d38b162f.svg";